"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestLogin = exports.requestPasswordPosition = exports.requestInteractionId = exports.requestAgentDataAsis = exports.requestAgentData = void 0;
const contactCenter_1 = require("../../../features/contactCenter");
/** @deprecated: use AssistedCCHelper instead */
const requestAgentData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ agentUsername, agentPassword, clientId, keycloakHost, }) {
    const urlencoded = new URLSearchParams();
    urlencoded.append('grant_type', 'password');
    urlencoded.append('client_id', clientId);
    urlencoded.append('username', agentUsername);
    urlencoded.append('password', agentPassword);
    const loginData = yield fetch(`${keycloakHost}/realms/master/protocol/openid-connect/token`, {
        body: urlencoded,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    const data = yield loginData.json();
    return {
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
    };
});
exports.requestAgentData = requestAgentData;
/** @deprecated: use AssistedCCHelper instead */
const requestAgentDataAsis = (_a) => __awaiter(void 0, [_a], void 0, function* ({ agentUsername, agentPassword, host, }) {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = {
        user: agentUsername,
        password: agentPassword,
    };
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
    };
    const response = yield fetch(`${host}/ccauthentication/agentauthentication`, requestOptions);
    const data = yield response.json();
    return data;
});
exports.requestAgentDataAsis = requestAgentDataAsis;
/** @deprecated: use AssistedCCHelper instead */
const requestInteractionId = (_a) => __awaiter(void 0, [_a], void 0, function* ({ agentUsername }) {
    const interactionId = (0, contactCenter_1.createInteractionId)();
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = {
        InteractionID: interactionId,
        Fecha: new Date().toISOString(),
        Tipo: 'voz',
        Agente: agentUsername,
    };
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
    };
    const response = yield fetch('https://wspre.genesys-bt.openbank.corp/WebAPIIV/Api/IV', requestOptions);
    const data = yield response.json();
    return data.interactionId;
});
exports.requestInteractionId = requestInteractionId;
/** @deprecated: use AssistedCCHelper instead */
const requestPasswordPosition = (_a) => __awaiter(void 0, [_a], void 0, function* ({ documentType, username, accessToken, host, }) {
    const myHeaders = new Headers();
    myHeaders.append('accessToken', accessToken);
    myHeaders.append('Content-Type', 'application/json');
    const raw = {
        documentType: documentType,
        username: username,
    };
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
    };
    const response = yield fetch(`${host}/mb-api-auth/authentication/users/password-positions`, requestOptions);
    const data = yield response.json();
    return data.positions;
});
exports.requestPasswordPosition = requestPasswordPosition;
/** @deprecated: use AssistedCCHelper instead */
const requestLogin = (_a) => __awaiter(void 0, [_a], void 0, function* ({ documentType, username, accessToken, password, passwordPositions, host, interactionId, }) {
    const myHeaders = new Headers();
    myHeaders.append('accessToken', accessToken);
    myHeaders.append('Content-Type', 'application/json');
    const raw = {
        documentType: documentType,
        password: password,
        passwordPosition: passwordPositions,
        username: username,
        deviceInformation: {
            deviceUUID: 'c49edf1f-8aff-41ba-abf5-7ff931a77001',
            webDeviceInfo: {
                version: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/95.0.4638.69 Safari/537.36',
            },
            sessionId: interactionId,
        },
    };
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
    };
    return fetch(`${host}/mb-api-auth/authentication/login`, requestOptions).then(response => response.json());
});
exports.requestLogin = requestLogin;
//# sourceMappingURL=helpers_deprecated.js.map